import * as stylex from "@stylexjs/stylex";
import { spacing, radii, colors } from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

import type { Position } from "./play-diagram-records";

export function Frame({
  at,
  children,
}: {
  readonly at: Position;
  readonly children: ReactNode;
}) {
  return (
    <div {...stylex.props(styles.frameOuter, framePlacement[at])}>
      <div data-figure-frame="true" {...stylex.props(styles.frame)}>
        <div {...stylex.props(styles.chrome)}>
          <span aria-hidden="true" {...stylex.props(styles.dots)}>
            <span {...stylex.props(styles.dot)} />
            <span {...stylex.props(styles.dot)} />
            <span {...stylex.props(styles.dot)} />
          </span>
        </div>
        <div data-figure-content="true" {...stylex.props(styles.frameContent)}>
          {children}
        </div>
      </div>
    </div>
  );
}

const framePlacement = stylex.create({
  card: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 1 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 1 },
  },
  board: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 3 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 1 },
  },
  standings: {
    gridColumnStart: { default: "auto", "@container (min-width: 560px)": 5 },
    gridRowStart: { default: "auto", "@container (min-width: 560px)": 1 },
  },
});

const styles = stylex.create({
  frameOuter: { display: "flex", width: "100%", justifyContent: "center" },
  frame: {
    display: "flex",
    height: {
      default: 192,
      "@container (min-width: 560px)": 224,
      "@container (min-width: 700px)": 260,
    },
    width: {
      default: "100%",
      "@container (min-width: 560px)": 176,
      "@container (min-width: 700px)": 216,
    },
    maxWidth: { default: 300, "@container (min-width: 560px)": "none" },
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: radii.medium,
    backgroundColor: colors.background,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    boxSizing: "border-box",
  },
  chrome: {
    position: "relative",
    display: "flex",
    height: 24,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    backgroundColor: colors.surfaceAlt,
  },
  dots: {
    position: "absolute",
    left: 10,
    display: "flex",
    gap: spacing.space6,
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: radii.pill,
    backgroundColor: colors.borderStrong,
  },
  frameContent: {
    display: "flex",
    minHeight: 0,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    padding: {
      default: spacing.space10,
      "@container (min-width: 700px)": spacing.space12,
    },
  },
});
